import { createRouter, createWebHistory } from 'vue-router'
import Education from '../views/Education.vue'
import Home from '../views/Home.vue'
import Projects from '../views/Projects.vue'
import Work from '../views/Work.vue'
import Skills from '../views/Skills.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/education',
    name: 'Education',
    component: Education
  },
  {
    path: '/projects',
    name: 'Projects',
    component: Projects
  },
  {
    path: '/work',
    name: 'Work',
    component: Work
  },
  {
    path: '/skills',
    name: 'Skills',
    component: Skills
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
